import {
  Component,
  ChangeDetectionStrategy,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  inject,
  effect,
} from '@angular/core';
import { TUI_DARK_MODE } from '@taiga-ui/core';
import { AppConfigService, AppConfigType } from '@src/app/modules/app-config';

import { LogoMode } from './types';
import { BASE_HEIGHT_HEADER_LOGO, BASE_HEIGHT_LOGO, BASE_WIDTH_HEADER_LOGO, BASE_WIDTH_LOGO } from './constants';
import { getLogoSrc } from './utils';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LogoComponent implements OnInit, OnChanges {
  private readonly appConfigService = inject(AppConfigService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly darkMode = inject(TUI_DARK_MODE);

  @Input({ required: true }) mode?: LogoMode;
  @Input() width?: number;
  @Input() height?: number;

  loading = true;
  src?: string;

  private appConfig$ = this.appConfigService.data$;

  constructor() {
    effect(() => {
      this.setData(this.appConfig$.value, this.darkMode());
      this.cdr.markForCheck();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['mode']) {
      this.setData(this.appConfig$.value, this.darkMode());
    }

    this.cdr.markForCheck();
  }

  ngOnInit(): void {
    this.appConfig$.subscribe(appConfig => {
      this.loading = appConfig === undefined;
      this.setData(appConfig, this.darkMode());

      this.cdr.markForCheck();
    });
  }

  private setData(appConfig: AppConfigType | null | undefined, isDarkTheme: boolean) {
    if (!appConfig) {
      return;
    }

    if (this.mode === 'logo') {
      this.src = getLogoSrc(appConfig, this.mode, isDarkTheme);
      this.width = this.width ?? BASE_WIDTH_LOGO;
      this.height = this.height ?? BASE_HEIGHT_LOGO;
    }

    if (this.mode === 'header-logo') {
      this.src = getLogoSrc(appConfig, this.mode, isDarkTheme);
      this.width = this.width ?? BASE_WIDTH_HEADER_LOGO;
      this.height = this.height ?? BASE_HEIGHT_HEADER_LOGO;
    }
  }
}
